import React from 'react';
import { Modal, Button, Badge, Accordion } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { useAuthContext } from '../../context/AuthContext';
import StyledDataTable from '../../components/StyledDataTable/StyledDataTable';

const SuccessModal = ({ show, onHide, importResult }) => {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) return null;

  const skippedColumns = [
    {
      name: 'Name',
      selector: row => row.name || row.contact_name || '-',
      sortable: true,
      grow: 2,
    },
    {
      name: 'Phone Number',
      selector: row => row.phone_number || row.phone || '-',
      sortable: true,
      width: '180px',
    },
    {
      name: 'Reason',
      selector: () => 'Number already exists',
      cell: () => <span className="text-warning">Number already exists</span>,
      width: '200px',
    }
  ];

  const errorColumns = [
    {
      name: 'Name',
      selector: row => row.name || row.contact_name || '-',
      sortable: true,
      grow: 2,
    },
    {
      name: 'Phone Number',
      selector: row => row.phone_number || row.phone || '-',
      sortable: true,
      width: '180px',
    },
    {
      name: 'Error Detail',
      selector: row => row.error || row.details || 'Unknown error',
      cell: row => <span className="text-danger">{row.error || row.details || 'Unknown error'}</span>,
      width: '250px',
    }
  ];

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center">
          <FaCheckCircle className="text-success me-2" /> 
          Import Results Summary
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-4 text-center">
          <div className="col-4">
            <div className="p-3 border rounded border-success bg-light">
              <h3 className="text-success m-0">{importResult.success?.length || 0}</h3>
              <small className="text-muted">Successfully Imported</small>
            </div>
          </div>
          <div className="col-4">
            <div className="p-3 border rounded border-warning bg-light">
              <h3 className="text-warning m-0">{importResult.skipped?.length || 0}</h3>
              <small className="text-muted">Skipped (Duplicates)</small>
            </div>
          </div>
          <div className="col-4">
            <div className="p-3 border rounded border-danger bg-light">
              <h3 className="text-danger m-0">{importResult.errors?.length || 0}</h3>
              <small className="text-muted">Failed to Import</small>
            </div>
          </div>
        </div>

        <Accordion>
          {importResult.skipped?.length > 0 && (
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <Badge bg="warning" className="me-2">{importResult.skipped.length}</Badge> 
                Skipped Duplicates Details
              </Accordion.Header>
              <Accordion.Body>
                <StyledDataTable
                  columns={skippedColumns}
                  data={importResult.skipped}
                  pagination={false}
                  noHeader
                  dense
                  responsive={false}
                />
              </Accordion.Body>
            </Accordion.Item>
          )}

          {importResult.errors?.length > 0 && (
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <Badge bg="danger" className="me-2">{importResult.errors.length}</Badge> 
                Failed Imports Details
              </Accordion.Header>
              <Accordion.Body>
                <StyledDataTable
                  columns={errorColumns}
                  data={importResult.errors}
                  pagination={false}
                  noHeader
                  dense
                  responsive={false}
                />
              </Accordion.Body>
            </Accordion.Item>
          )}
        </Accordion>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Done
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessModal;
